/**
 * Constantes para o módulo de Projetos
 */

export const STATUS_CONFIG = {
  'nao_iniciado': { label: 'Não Iniciado', color: 'bg-gray-100 text-gray-700', iconName: 'Clock' },
  'em_producao': { label: 'Em Produção', color: 'bg-blue-100 text-blue-700', iconName: 'Ship' },
  'em_atraso': { label: 'Em Atraso', color: 'bg-red-100 text-red-700', iconName: 'AlertTriangle' },
  'concluido': { label: 'Concluído', color: 'bg-green-100 text-green-700', iconName: 'CheckCircle2' },
  'Planning': { label: 'Planejamento', color: 'bg-yellow-100 text-yellow-700', iconName: 'Clock' },
  'In Progress': { label: 'Em Produção', color: 'bg-blue-100 text-blue-700', iconName: 'Ship' },
  'Completed': { label: 'Concluído', color: 'bg-green-100 text-green-700', iconName: 'CheckCircle2' }
};

export const ESCLARECIMENTOS_PROJETO = [
  { item: "Cores gerais", checked: false, observacao: "" },
  { item: "Fonte e logotipo", checked: false, observacao: "" },
  { item: "Equipamentos gerais", checked: false, observacao: "" },
  { item: "Salvagem", checked: false, observacao: "" },
  { item: "Carreta", checked: false, observacao: "" },
  { item: "Prazo de entrega", checked: false, observacao: "" }
];

export const PROJETO_FORM_INICIAL = {
  name: '',
  client: '',
  vessel_type: '',
  factory_id: '',
  factory_name: '',
  responsavel_tecnico: '',
  numero_empenho: '',
  start_date: new Date().toISOString().split('T')[0],
  delivery_date: '',
  budget: 0,
  valor_venda: 0,
  custo_estimado_manual: 0,
  margem_alvo_pct: '',
  google_drive_url: '',
  description: '',
  embarcacoes: [],
  anexos: []
};

/**
 * Calcula o status da especificação baseado nas embarcações
 */
export const getSpecStatus = (embarcacoes) => {
  if (!embarcacoes || embarcacoes.length === 0) {
    return { status: 'vazio', label: 'Sem embarcações', color: 'bg-gray-200 text-gray-600' };
  }
  
  let totalProgress = 0;
  embarcacoes.forEach(emb => {
    const checklistProgress = emb.progresso_checklist || 0;
    totalProgress += checklistProgress;
  });
  const avgProgress = totalProgress / embarcacoes.length;
  
  if (avgProgress === 0) return { status: 'vazio', label: 'Não preenchido', color: 'bg-gray-200 text-gray-600' };
  if (avgProgress === 100) return { status: 'completo', label: 'Completo', color: 'bg-green-100 text-green-700' };
  return { status: 'parcial', label: `${Math.round(avgProgress)}% preenchido`, color: 'bg-yellow-100 text-yellow-700' };
};

/**
 * Formata valor monetário
 */
export const formatMoney = (value) => {
  return new Intl.NumberFormat('pt-BR', { 
    style: 'currency', 
    currency: 'BRL' 
  }).format(value || 0);
};

/**
 * Formata data para exibição
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR');
  } catch {
    return dateStr;
  }
};


/**
 * Formata tempo relativo em português ("há 5 min", "há 2 h", "há 3 dias")
 */
export const formatRelativeTime = (iso) => {
  if (!iso) return '';
  try {
    const past = new Date(iso).getTime();
    const now = Date.now();
    const diffSec = Math.max(0, Math.floor((now - past) / 1000));
    if (diffSec < 60) return 'agora mesmo';
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `há ${diffMin} min`;
    const diffH = Math.floor(diffMin / 60);
    if (diffH < 24) return `há ${diffH} h`;
    const diffD = Math.floor(diffH / 24);
    if (diffD < 30) return `há ${diffD} dia${diffD > 1 ? 's' : ''}`;
    const diffM = Math.floor(diffD / 30);
    if (diffM < 12) return `há ${diffM} mês${diffM > 1 ? 'es' : ''}`;
    const diffY = Math.floor(diffM / 12);
    return `há ${diffY} ano${diffY > 1 ? 's' : ''}`;
  } catch {
    return '';
  }
};
